/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Mark_Processed_SuccessInputs */

const vi_tea_purchase_mark_processed_success = /** @type {(inputs: Tea_Purchase_Mark_Processed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ghi nhận sản xuất`)
};

/**

* @param {Tea_Purchase_Mark_Processed_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_mark_processed_success = /** @type {((inputs?: Tea_Purchase_Mark_Processed_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Mark_Processed_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_mark_processed_success(inputs)
});